// Module
var code = "<span>{{$ctrl.displayTime}}</span> ";
// Exports
export default code;